import classNames from 'classnames';
import * as React from 'react';

import '../../../styles/InputCheckbox.scss';

interface IProps {
  isFocused: boolean;
  isLoading: boolean;
  name?: string;
  value?: string;
  fullWidth?: boolean;
  checked?: boolean;
  defaultValue?: boolean;
  readOnly?: boolean;
  label: string;
  type: string;
  onChange: (name: string, value: boolean) => void;
  additionalClass?: string;
  isDisabled?: boolean;
}

export function InputCheckbox(props: IProps) {
  return (
    <label
      htmlFor={props.name}
      tabIndex={0}
      className={classNames('checkboxLabel', {
        checked: props.checked,
        disabled: props.isDisabled,
      })}
      style={props.name === 'agb-read-and-accepted' ? { paddingLeft: '80px', zIndex: 1 } : {}}
      onKeyPress={(event) => {
        var code = event.keyCode || event.which;
        if (code === 13) {
          props.onChange(props.name, !props.checked);
        }
      }}
    >
      <input
        tabIndex={-1}
        id={props.name}
        className={'checkboxInput'}
        type='checkbox'
        readOnly={props.readOnly}
        name={props.name}
        checked={props.checked}
        defaultChecked={props.defaultValue}
        value={props.value}
        disabled={props.isDisabled}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          props.onChange && props.onChange(e.currentTarget.name, e.currentTarget.checked);
        }}
      />

      {props.label}

      {/*TODO:: need to refine spinner UI*/}
      {/*<i className={classNames('checkboxMark')}>*/}
      {/*    {props.isLoading ? (*/}
      {/*        <div className={'checkboxSpinner'}>*/}
      {/*            <SpinnerV2 relative inText/>*/}
      {/*        </div>*/}
      {/*    ) : (*/}
      {/*        <IconCheckmark/>*/}
      {/*    )}*/}
      {/*</i>*/}
    </label>
  );
}
